module.exports = __webpack_public_path__ + "static/media/visal-logo-big.326e6f00.png";